var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAwsKinesis(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    viewBox: "0 0 79.732 96",
    width: 2083,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 53.597 39.79 18.316 39.788-18.316-39.789-1.649z",
    fill: "#fcbf92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.911 0-39.893 19.896v28.073h47.836v-43.999z",
    fill: "#9d5025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.018 67.76 39.917 28.24 39.795-28.24-39.883-5.804z",
    fill: "#fcbf92"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#9d5025"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.911 47.969h21.047v-29.956l-6.146-2.458-14.9 4.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.812 47.969h16.268v-19.43l-4.653-1.396-11.615 1.972z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.427 25.62v22.349h13.15l.155-22.448-3.995-1.596z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m39.911 0v47.969h7.943v-43.999zm21.047 18.013-6.146-2.458v32.414h6.146zm10.122 10.526-4.653-1.396v20.827h4.653zm4.657 19.43h3.994v-22.449l-3.994-1.596zm-35.947 9.607v14.337l39.788-9.918v-8.398zm0 24.268v14.156l39.94-19.97v-8.27z",
    fill: "#f68534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.018 76.116 39.772 19.884v-14.26l-39.77-13.981zm-.018-14.121 39.79 9.918v-14.337l-39.79-3.98z",
    fill: "#9d5025"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsKinesis);
export default __webpack_public_path__ + "static/media/aws-kinesis.10ad2f0c45ae51bba833297194b039b5.svg";
export { ForwardRef as ReactComponent };